import React, { useState } from 'react'
import { v4 as uuid } from 'uuid'
import { showNotification } from '@/state/user-interface'
import { useAppDispatch } from '@/utils/hooks'
import { Chat } from './chat'
import { TopBar } from './top-bar'

type Props = {
	setChatOpen: (chatOpen: boolean) => void
}

export const ChatInterface = ({ setChatOpen }: Props) => {
	const [chatId, setChatId] = useState(uuid())
	const dispatch = useAppDispatch()
	const resetChatId = () => {
		setChatId(uuid())
		dispatch(showNotification({ content: 'Chat has been reset and sent for processing', type: 'neutral' }))
	}
	return (
		<>
			<TopBar setChatOpen={setChatOpen} />
			<Chat key={chatId} chatId={chatId} resetChatId={resetChatId} />
		</>
	)
}
